var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69334 13.0133C3.28667 13.0133 2.90667 12.8733 2.63334 12.6133C2.28667 12.2867 2.12001 11.7933 2.18001 11.26L2.42667 9.10001C2.47334 8.69334 2.72001 8.15334 3.00667 7.86001L8.48001 2.06667C9.84667 0.620007 11.2733 0.580007 12.72 1.94667C14.1667 3.31334 14.2067 4.74001 12.84 6.18667L7.36667 11.98C7.08667 12.28 6.56667 12.56 6.16001 12.6267L4.01334 12.9933C3.90001 13 3.80001 13.0133 3.69334 13.0133ZM10.62 1.94001C10.1067 1.94001 9.66001 2.26001 9.20667 2.74001L3.73334 8.54001C3.60001 8.68001 3.44667 9.01334 3.42001 9.20667L3.17334 11.3667C3.14667 11.5867 3.20001 11.7667 3.32001 11.88C3.44001 11.9933 3.62001 12.0333 3.84001 12L5.98667 11.6333C6.18001 11.6 6.50001 11.4267 6.63334 11.2867L12.1067 5.49334C12.9333 4.61334 13.2333 3.80001 12.0267 2.66667C11.4933 2.15334 11.0333 1.94001 10.62 1.94001Z",
    fill: "#303E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 7.3C11.5467 7.3 11.5267 7.3 11.5133 7.3C9.43333 7.09333 7.76 5.51333 7.44 3.44666C7.4 3.17333 7.58666 2.92 7.86 2.87333C8.13333 2.83333 8.38666 3.02 8.43333 3.29333C8.68666 4.90666 9.99333 6.14666 11.62 6.30666C11.8933 6.33333 12.0933 6.58 12.0667 6.85333C12.0333 7.10666 11.8133 7.3 11.56 7.3Z",
    fill: "#303E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.596656dbe377383b6a7337f32df7c061.svg";
export { ForwardRef as ReactComponent };